module.exports = __webpack_public_path__ + "static/media/Balsamiq.62a6837e.svg";